import React from 'react';
// import { renderWithTrans } from '@/utils/render';
import { render } from 'react-snapshot';

import App from './App';

// renderWithTrans(<App />);
render(
	<App/>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
